module.exports = __webpack_public_path__ + "img/1.de46ba76.png";